<label class="esf-form-item__label">{{ label }}
  <app-optional *ngIf="optional"></app-optional>
</label>
<label [for]="id" class="esf-button esf-button--standard esf-button--outlined esf-file-upload__button">
  <svg class="esf-icon esf-button__icon" width="16" height="16">
    <use xlink:href="#esf-icon-upload"></use>
  </svg>
  <span id="importFileLabel" class="esf-button__icon-text">
            <span *ngIf="fileToUpload !== null">{{ fileToUpload.name }}</span>
            <span *ngIf="fileToUpload === null" i18n="@@general.formLabel.selectFile">Select a file</span>
          </span>
</label>
<input class="esf-form-item__field esf-file-upload__input" type="file" [id]="id" (change)="fileChange($event.target)">
